import styled from 'styled-components'
import { Attribution, colors } from '@giphy/react-giphy-brand'
import Bio from 'shared/components/user/description'
import Social from 'shared/components/user/social'

const Wrapper = styled.div`
    background: ${colors.dimColor};
    box-sizing: border-box;
    height: 100%;
    left: 0;
    opacity: 0;
    padding: 10px 10px 60px 10px;
    position: absolute;
    top: 0;
    transition: opacity 0.2s ease-out;
    width: 100%;
`

const Container = styled.div`
    box-sizing: border-box;
    height: 100%;
    left: 0;
    position: absolute;
    text-align: left;
    top: 0;
    transition: opacity 0.2s ease-out;
    width: 100%;

    &:before {
        content: '';
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));
        bottom: 0;
        height: 70px;
        left: 0;
        pointer-events: none;
        position: absolute;
        width: 100%;
    }

    div:hover > & {
        ${Wrapper} {
            opacity: 1;
        }
    }
`

const Info = styled.div`
    color: ${colors.giphyWhite};
    line-height: 1.4;
    height: 100%;
    overflow-y: auto;
    position: relative;
    width: 100%;
    ::-webkit-scrollbar {
        display: none;
    }

    p {
        color: ${colors.giphyWhite};
    }
`

const User = styled.div`
    bottom: 10px;
    left: 10px;
    position: absolute;
    right: 10px;
`

const ArtistPreview = ({ user = {} }) => {
    const { description, website_url } = user
    const showDescription = !!description || !!website_url
    return (
        <Container>
            <Wrapper>
                <Info>
                    {showDescription && <Bio {...user} />}
                    <Social {...user} />
                </Info>
            </Wrapper>
            <User>
                <Attribution user={user} />
            </User>
        </Container>
    )
}

export default ArtistPreview
